import { render, staticRenderFns } from "./FastMail.vue?vue&type=template&id=5c746e3b&scoped=true"
import script from "./FastMail.vue?vue&type=script&lang=ts"
export * from "./FastMail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c746e3b",
  null
  
)

export default component.exports